import { render, staticRenderFns } from "./ShopProductDetails.vue?vue&type=template&id=b058bba2&"
import script from "./ShopProductDetails.vue?vue&type=script&lang=js&"
export * from "./ShopProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports